import React, { useState } from "react";
import { downloadImageWithReferral } from "../utils/helpers";
import "../styles/app.css";
import "../styles/toast.css";
import ToastNotification from "./ToastNotification";

function formatDateIST(isoString) {
  const date = new Date(isoString);
  return date.toLocaleDateString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "Asia/Kolkata"
  });
}

export function sanitizeTitleForFilename(title) {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s]/gi, "") // Remove special characters
    .replace(/\s+/g, "_"); // Replace spaces with underscores
}

export default function ResourceCard({ referralCode, resources }) {
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const handleDownload = async (res, index) => {
    setLoadingIndex(index);
    setShowToast(true);

    const { url } = res.resource;
    const title = res.title;

    if (res.type === "image") {
      await downloadImageWithReferral(url, referralCode, sanitizeTitleForFilename(title));
    } else {
      if (window.RoyalSkyWebViewDownloads?.postMessage) {
        window.RoyalSkyWebViewDownloads.postMessage(url);
      } else {
        console.log({
          type: "video",
          name: sanitizeTitleForFilename(title),
          url: url
        });
      }
    }

    setTimeout(() => {
      setLoadingIndex(null);
      setShowToast(false);
    }, 6000);
  };

  return (
    <>
      <div className="card-grid">
        {resources.map((res, idx) => (
          <div key={idx} className="resource-card">
            {res.type === "image" ? (
              <img src={res.resource.url} alt={res.title} className="resource-img" />
            ) : (
              <video controls className="resource-img">
                <source src={res.resource.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
            <h4>{res.title}</h4>
            <p className="small">{formatDateIST(res.post_date)}</p>
            <button onClick={() => handleDownload(res, idx)} disabled={loadingIndex === idx}>
              {loadingIndex === idx ? "Downloading..." : "Download"}
            </button>
          </div>
        ))}
      </div>

      {showToast && <ToastNotification message="Download will start shortly, please wait..." />}
    </>
  );
}